<div class="title">De-activate User?</div>

<div class="subtitle">
  <span>Are you sure you want to de-activate this user</span>
  <span class="user-name">{{ fullName }} ?</span>
</div>

<div class="actions">
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button (click)="deactivate()" mat-flat-button color="warn">De-activate</button>
</div>